import * as React from 'react';
import { FC } from 'react';

interface IconProps {
  color?: string;
  size?: number;
  style?: React.CSSProperties;
}

const Next: FC<IconProps> = ({ color = 'white', size = 12, style }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 100 100" 
    fill={color} 
    style={style}
  >
    <path d="M84.15,48.09L52.29,29.7c-0.34-0.2-0.72-0.3-1.1-0.3s-0.76,0.1-1.1,0.3c-0.69,0.4-1.1,1.11-1.1,1.91v15.95L18.05,29.7  c-0.34-0.2-0.72-0.3-1.1-0.3s-0.76,0.1-1.1,0.3c-0.69,0.4-1.1,1.11-1.1,1.91V68.4c0,0.8,0.41,1.51,1.1,1.91c0.69,0.4,1.51,0.4,2.2,0  l30.94-17.86V68.4c0,0.8,0.41,1.51,1.1,1.91c0.69,0.4,1.51,0.4,2.2,0l31.86-18.4c0.69-0.4,1.1-1.11,1.1-1.91  S84.84,48.49,84.15,48.09z" />
  </svg>
);

export default Next;